export enum UserDocumentType {
  Pdf = "pdf",
  Excel = "excel",
  Word = "word",
  PowerPoint = "powerpoint",
  Text = "text",
}
